import React from "react";
// reactstrap components
import tt2 from "../../assets/img/tt2.png"

import {
  Button,
  Container,
  Row,
  Col,
  Carousel,
  CarouselItem,
  CarouselIndicators,
} from "reactstrap";
import { useTranslation } from 'react-i18next';
const lngs = {
  en: { nativeName: 'English' },
  es: { nativeName: 'Spanish' }
};
// const { t } = useTranslation();


function SectionHeader() {
  const { t } = useTranslation();

// core components
const items = [
  {
    src: "url(" + require("assets/img/sb1.jpg") + ")",
    content: (
      <Container>
        <Row>
          <Col className="text-left" md="6">
            <h1 className="title">BEACH TOURS CARTAGENA</h1>
            <h5>
        
          <p>
          {t('description.part1')}
          </p>
            </h5>
            <br />
            <div className="buttons">
            <Button
                className="btn-round"
                color="danger"
                href="/about-us"
                size="lg"
              >
          {t('description.part4')}
          </Button>
            
              <Button
                className="btn-neutral btn-just-icon"
                color="link"
                href="https://facebook.com"
              >
                <i className="fa fa-facebook-square" />
              </Button>
          
              <Button
                className="btn-neutral btn-just-icon"
                color="link"
                href="https://www.tiktok.com/@btcartagenaonline"
              >
               <img src={tt2} style={{height:"16px"}}/>
              </Button>
              <Button
                className="btn-neutral btn-just-icon"
                color="link"
                href="https://www.instagram.com/btcartagenaonline"
              >
                <i className="fa fa-instagram" />
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    ),
    altText: "",
    caption: "",
  },
  {
    src: "url(" + require("assets/img/pic2.jpeg") + ")",
    
    content: (
      <Container>
        <Row>
          <Col className="ml-auto mr-auto text-center" md="8">
          <h1 className="title">BEACH TOURS CARTAGENA</h1>
            <h5>
        
          <p>
          {t('description.part2')}
          </p></h5>
            <br />
            <h6>Connect with us:</h6>
        
              <Button
                className="btn-neutral btn-just-icon"
                color="link"
                href="https://facebook.com"
              >
                <i className="fa fa-facebook-square" />
              </Button>
              <Button
                className="btn-neutral btn-just-icon"
                color="link"
                href="https://www.tiktok.com/@btcartagenaonline"

              >
                            <img src={tt2} style={{height:"16px"}}/>

              </Button>
              <Button
                className="btn-neutral btn-just-icon"
                color="link"
                href="https://www.instagram.com/btcartagenaonline"
              >
                <i className="fa fa-instagram" />
              </Button>
          </Col>
        </Row>
      </Container>
    ),
    altText: "",
    caption: "",
  },
  {
    src: "url(" + require("assets/img/sb2.jpg") + ")",
    content: (
      <Container>
        <Row>
          <Col className="ml-auto text-right" md="7">
          <h1 className="title">BEACH TOURS CARTAGENA</h1>
            <h5>
        
          <p>
          {t('description.part3')}
          </p></h5>
            <br />
            <div className="buttons">
              {/* <Button
                className="btn-neutral"
                color="link"
                href="#pablo"
                onClick={(e) => e.preventDefault()}
                size="lg"
              >
                <i className="fa fa-share-alt" />
                Share Offer
              </Button> */}
              <Button
                className="btn-round"
                color="success"
                href="/contact-us"
                size="lg"
              >
                <i className="fa fa-shopping-cart" />
                {t('description.part5')}
                </Button>
            </div>
          </Col>
        </Row>
      </Container>
    ),
    altText: "",
    caption: "",
  },
];
  // carousel - header 3
  const [activeIndex, setActiveIndex] = React.useState(0);
  const [animating, setAnimating] = React.useState(false);
  const onExiting = () => {
    setAnimating(true);
  };
  const onExited = () => {
    setAnimating(false);
  };
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };
  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };
  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  // video - header 4
  const [videoPlaying, setVideoPlaying] = React.useState(false);
  const videoRef = React.createRef();
  const videoButtonClick = () => {
    if (videoPlaying) {
      setVideoPlaying(false);
      videoRef.current.pause();
    } else {
      setVideoPlaying(true);
      videoRef.current.play();
    }
  };
  return (
    <>
     <div className="header-4">
          <div className="header-wrapper">
       
            {/* <Navbar className="navbar-transparent navbar-absolute" expand="lg">
              <Container>
                <NavbarBrand className="mb-0" href="www.creative-tim.com">
                  Creative Tim
                </NavbarBrand>
                <button
                  className="navbar-toggler"
                  id="navbarSupportedContent4"
                  type="button"
                >
                  <span className="navbar-toggler-bar" />
                  <span className="navbar-toggler-bar" />
                  <span className="navbar-toggler-bar" />
                </button>
                <UncontrolledCollapse navbar toggler="#navbarSupportedContent4">
                  <Nav className="ml-auto" navbar>
                    <Button
                      className="btn-neutral"
                      color="link"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      Components
                    </Button>
                    <Button
                      className="btn-neutral"
                      color="link"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      Tutorial
                    </Button>
                    <Button
                      className="btn-neutral"
                      color="link"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      target="_blank"
                    >
                      <i className="fa fa-twitter" />
                    </Button>
                    <Button
                      className="btn-neutral"
                      color="link"
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      target="_blank"
                    >
                      <i className="fa fa-facebook" />
                    </Button>
                  </Nav>
                </UncontrolledCollapse>
              </Container>
            </Navbar> */}

            {/* <div className="page-header header-video">
           
              <div className="content-center">
                <Container className="upper-container text-center">
                <Button
                    color="danger"
                    size="xs"
                    type="button"
                    onClick={videoButtonClick}
                  >
                    {videoPlaying ? (
                      <i className="fa fa-pause"></i>
                    ) : (
                      <i className="fa fa-play" />
                    )}
                    {videoPlaying ? " Pause" : " Play"}
                  </Button>
                  <div className="video-text">
                  
                  </div>
                  <br />
                
                </Container>
              </div>
          </div> */}

        </div>
        {/* ********* HEADER 3 ********* */}
        <div className="header-3">
           
          <div className="page-carousel">
            <div className="filter" />
            <Carousel activeIndex={activeIndex} next={next} previous={previous}>
              <CarouselIndicators
                items={items}
                activeIndex={activeIndex}
                onClickHandler={goToIndex}
              />
              {items.map((item) => {
                return (
                  <CarouselItem
                    onExiting={onExiting}
                    onExited={onExited}
                    key={item.src}
                  >
                    <div
                      className="page-header"
                      style={{ backgroundImage: item.src }}
                    >
                      <div className="filter" />
                      <div className="content-center">{item.content}</div>
                    </div>
                  </CarouselItem>
                );
              })}
              <a
                className="left carousel-control carousel-control-prev"
                data-slide="prev"
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  previous();
                }}
                role="button"
              >
                <span className="fa fa-angle-left" />
                <span className="sr-only">Previous</span>
              </a>
              <a
                className="right carousel-control carousel-control-next"
                data-slide="next"
                href="#pablo"
                onClick={(e) => {
                  e.preventDefault();
                  next();
                }}
                role="button"
              >
                <span className="fa fa-angle-right" />
                <span className="sr-only">Next</span>
              </a>
            </Carousel>
          </div>
        </div></div>
        {/* ********* END HEADER 3 ********* */}
       
    </>
  );
}

export default SectionHeader;
